import axios from 'axios'

export default () => ({
  open(event, account) {

    axios.get('/account/shipping-accounts/ajax/delete', {
      params: {
        account: account
      }
    })
      .then(response => {
        this.$dispatch('modal-open', {
          content: response.data.template
        })
      })
  }
})
